module.exports = __webpack_public_path__ + "static/media/Kudos Titan 606 Speakers.a6da9e06.jpg";